
// ****************************************************************
// PROD
// ****************************************************************
let prodConfig = {
  endpoints: {
    getOpenId: 'https://api.nike.com.cn/wx/v3/User/getUserinfo/oa/run',
    shareConfig: 'https://api.nike.com.cn/wx/v3/js/share/oa/run/',
    getRank: 'https://a.nike.com.cn/fast/api/v3/activity/getrank',
    detail: 'https://a.nike.com.cn/fast/api/v3/activity/detail'
  }
}



// ****************************************************************
// DEV
// ****************************************************************
let devConfig = {
  endpoints: {
    getOpenId: 'https://cn-nike-api.akqa-uat.com/wx/v3/User/getUserinfo/oa/test',
    shareConfig: 'https://cn-nike-api.akqa-uat.com/wx/v3/js/share/oa/test',
    getRank: 'https://cn-nike-a.akqa-uat.com/fast/api/v3/activity/getrank',
    detail: 'https://cn-nike-a.akqa-uat.com/fast/api/v3/activity/detail'
  }
}



// ****************************************************************
// CONDITIONAL
// ****************************************************************
let config
if (process.env.NODE_ENV === 'production') {
  config = prodConfig
  config = devConfig // DEBUG / UAT
} else {
  config = devConfig
}

export default config


// WEBPACK FOOTER //
// ./src/config/api.js